import * as React from "react"
import type { SVGProps } from "react"
const SvgLayout = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5 19V5h4v14zm10 0h4v-5h-4zm0-11V5h4v3zM3.59 20.4q.59.6 1.41.59h4q.82 0 1.41-.59.6-.58.59-1.41V5q0-.82-.59-1.41A2 2 0 0 0 9 3H5q-.82 0-1.41.59A2 2 0 0 0 3 5v14q0 .83.59 1.41Zm10 0q.59.6 1.41.59h4q.83 0 1.41-.59.6-.58.59-1.41v-5q0-.83-.59-1.41A2 2 0 0 0 19 12h-4q-.83 0-1.41.59A2 2 0 0 0 13 14v5q0 .83.59 1.41m0-11q.59.6 1.41.59h4q.83 0 1.41-.59.6-.59.59-1.41V5q0-.82-.59-1.41A2 2 0 0 0 19 3h-4q-.83 0-1.41.59A2 2 0 0 0 13 5v3q0 .82.59 1.41"
    />
  </svg>
)
export default SvgLayout
